import {getIncomers, getOutgoers} from 'reactflow';


export default class DFS {
    validWay = false
    reachableFromStart = []
    reachableFromEnd = []
    mainStrain = []
    cycles = []
    unreachable = []
    looseConstruct = []

    constructor(nodes, edges) {
        this.nodes = nodes
        this.edges = edges
    }

    dfsValidWay(node) {

        if (this.reachableFromStart.includes(node.id)) {
            return
        }

        this.reachableFromStart.push(node.id)

        if (node.id === 'endOfWorkflow') {
            this.validWay = true
            return
        }

        const outgoers = getOutgoers(node, this.nodes, this.edges)

        for (const outgoer of outgoers) {
            this.dfsValidWay(outgoer)
        }
    }

    dfsFromEnd(node) {

        if (this.reachableFromEnd.includes(node.id)) {
            return
        }

        this.reachableFromEnd.push(node.id)

        if (node.id === 'startOfWorkflow') {
            return
        }

        const incomers = getIncomers(node, this.nodes, this.edges)

        for (const incomer of incomers) {
            this.dfsFromEnd(incomer)
        }
    }

    trajansSCCAlgorithm() {
        const self = this

        let index = 0
        let stack = []
        // bookkeeping per node id instead of on the nodes themselves,
        // so frozen nodes (e.g. from the redux store) can be validated
        const meta = new Map()

        for (const node of this.nodes) {
            if (!meta.has(node.id)) {
                strongConnect(node)
            }
        }

        function strongConnect(node) {
            const nodeMeta = { index: index, lowlink: index, onStack: true }
            meta.set(node.id, nodeMeta)
            index += 1
            stack.push(node)

            const outgoers = getOutgoers(node, self.nodes, self.edges)

            for (const outgoer of outgoers) {
                const outgoerMeta = meta.get(outgoer.id)
                if (outgoerMeta === undefined) {
                    strongConnect(outgoer)
                    nodeMeta.lowlink = Math.min(nodeMeta.lowlink, meta.get(outgoer.id).lowlink)
                } else if (outgoerMeta.onStack) {
                    nodeMeta.lowlink = Math.min(nodeMeta.lowlink, outgoerMeta.index)
                }
            }

            if (nodeMeta.lowlink === nodeMeta.index) {
                let ssc = []
                let w

                do {
                    w = stack.pop()
                    meta.get(w.id).onStack = false
                    ssc.push(w)
                } while (w !== node)

                if (ssc.length > 1) {
                    self.cycles.push(ssc)
                }
            }
        }
    }

    dfsBidirectional(node) {

        if (this.mainStrain.includes(node.id)) {
            return
        }

        this.mainStrain.push(node.id)

        const outgoers = getOutgoers(node, this.nodes, this.edges)
        const incomers = getIncomers(node, this.nodes, this.edges)

        for (const outgoer of outgoers) {
            this.dfsBidirectional(outgoer)
        }

        for (const incomer of incomers) {
            this.dfsBidirectional(incomer)
        }
    }

    dfsLooseConstruct(node, affectedNodes) {

        if (this.looseConstruct.includes(node.id)) {
            return
        }

        this.looseConstruct.push(node.id)
        affectedNodes.push(node)

        const outgoers = getOutgoers(node, this.nodes, this.edges)
        const incomers = getIncomers(node, this.nodes, this.edges)

        for (const outgoer of outgoers) {
            this.dfsLooseConstruct(outgoer, affectedNodes)
        }

        for (const incomer of incomers) {
            this.dfsLooseConstruct(incomer, affectedNodes)
        }
    }

    dfsUntilReachable(node, affectedNodes) {
        if (this.reachableFromStart.includes(node.id)) {
            return
        }

        if (this.unreachable.includes(node.id)) {
            return
        }

        this.unreachable.push(node.id)
        affectedNodes.push(node)

        if (node.id === 'endOfWorkflow') {
            return
        }

        const outgoers = getOutgoers(node, this.nodes, this.edges)
        const incomers = getIncomers(node, this.nodes, this.edges)

        for (const outgoer of outgoers) {
            this.dfsUntilReachable(outgoer, affectedNodes)
        }

        for (const incomer of incomers) {
            this.dfsUntilReachable(incomer, affectedNodes)
        }
    }
}